import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TaskService {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  deleteUnitApplication(payload) {
    return this._http.delete(
      this.baseUrl +
        `/organization/${payload.organizationId}/unit/${payload.organizationUnitId}/application/${payload.applicationId}/`
    );
  }
  getALLCompany(payload) {
    return this._http.get(this.baseUrl + '/enterprise_org/', {
      params: payload.params,
    });
  }
  getMyTasks(payload) {
    return this._http.get(this.baseUrl + `/change-request/monitorings/`, {
      params: payload.params,
    });
  }

  getAllTasks(payload) {
    return this._http.get(this.baseUrl + `/change-request/monitorings/all/`, {
      params: payload.params,
    });
  }
  getDashboardData(payload) {
    return this._http.get(this.baseUrl + `/change-request/dashboard-data/`, {});
  }
  getCacData(payload) {
    return this._http.get(
      this.baseUrl +
        `/contractors/${payload.companyTypeId}/cac_data/${payload.rcNumber}/`,
      {}
    );
  }
  getTinData(payload) {
    return this._http.get(
      `https://apps.firs.gov.ng/apis/tinvalidation/${payload.tinNumber}`,
      {}
    );
  }
  acceptOrRejectUpdate(payload) {
    return this._http.post(
      this.baseUrl + `/change-request/monitorings/approval/`,
      payload.body
    );
  }

  getRequestHistory(payload) {
    return this._http.get(
      this.baseUrl +
        `/change-request/type/${payload.changeRequestType}/history/`,
      { params: payload.params }
    );
  }
  getRequestDocument(payload) {
    return this._http.get(
      this.baseUrl +
        `/change-request/get-documents/${payload.changeRequestType}/`
    );
  }
  checkUserVerify(payload) {
    return this._http.get(
      this.baseUrl +
        `/change-request/can-verify/${payload.approvalMonitoringId}/`
    );
  }
  editUnitApplication(payload) {
    return this._http.put(
      this.baseUrl +
        `/organization_units/${payload.id}/applications/${payload.applicationId}/`,
      payload.body
    );
  }
  updateValueRequest(payload) {
    return this._http.put(
      this.baseUrl +
        `/change-request/update/?changeRequestId=${payload.changeRequestId}`,
      payload.body
    );
  }

  addUnitApplication(payload) {
    return this._http.post(
      this.baseUrl +
        `/organization_units/${payload.id}/applications/${payload.applicationId}/`,
      payload.body
    );
  }

  getUnit(payload) {
    return this._http.get(
      this.baseUrl + `/organization/${payload.organizationId}/units/`,
      {
        params: payload.params,
      }
    );
  }

  addUnit(payload) {
    console.log('add');
    return this._http.post(
      this.baseUrl + `/organization/${payload.organizationId}/unit/`,
      payload.body
    );
  }

  updateUnit(payload) {
    console.log('update');
    return this._http.put(
      `${this.baseUrl}/organization/${payload.organizationId}/unit/${payload.id}/`,
      payload.body
    );
  }

  deleteUnit(payload) {
    return this._http.delete(
      `${this.baseUrl}/organization/${payload.organizationId}/unit/${payload.id}/`
    );
  }

  getNoUnitUsers(payload) {
    return this._http.get(
      this.baseUrl +
        `/organization/${payload.organizationId}/unassigned-unit-users/`,
      {
        params: payload.params,
      }
    );
  }

  getUnitUsers(payload) {
    return this._http.get(
      this.baseUrl +
        `/organization/${payload.organizationId}/unit/${payload.organizationUnitId}/users/`,
      {
        params: payload.params,
      }
    );
  }

  addUnitUser(payload) {
    return this._http.post(
      this.baseUrl +
        `/organization/${payload.organizationId}/unit/${payload.organizationUnitId}/users/`,
      payload.body
    );
  }

  deleteUnitUser(payload) {
    return this._http.delete(
      this.baseUrl +
        `/organization/${payload.organizationId}/unit/${payload.organizationUnitId}/user/${payload.appUserId}/`
    );
  }
}
